/**
 * User context utilities for address components
 * Provides access to user ID and country ID from meta tags
 */

/**
 * Gets the current user ID from meta tag or window.jiffy
 * @returns {string|null} User ID as string or null if not found
 */
export function getUserId() {
  const $userIdMeta = document.head.querySelector('meta[property="user_id"]');
  if (!$userIdMeta) return null;

  const userId = window.jiffy?.userId || $userIdMeta.content;
  return userId ? String(userId) : null;
}

/**
 * Gets the country ID from meta tag
 * @returns {string|null} Country ID or null if not found
 */
export function getCountryId() {
  const $countryIdMeta = document.head.querySelector('meta[property="country_id"]');
  return $countryIdMeta?.content ?? null;
}

/**
 * Gets the current order number from window.jiffy
 * Returns null if window.jiffy or orderNumber is not available
 *
 * @returns {string|null} Order number or null
 * @static
 */
export function getOrderNumber() {
  const $orderNumberContainer = document.querySelector(".js-order-number-container");

  if (!$orderNumberContainer) return null;

  const orderNumber = window.jiffy?.orderNumber || $orderNumberContainer.dataset.orderNumber;

  return orderNumber ? String(orderNumber) : null;
}
